import { ThemeProvider } from '@emotion/react'
import { LoadingSpinner, PAYPAL_THEME } from '@paypalcorp/pp-react'
import { ContextProvider as WorldReadyContextProvider } from '@paypalcorp/worldready-react'
import PropTypes from 'prop-types'
import React, { useEffect, useRef } from 'react'
import Footer from './components/footer'
import Header from './components/header'
import { AppContextProvider } from './contexts/app-context'
import Page from './page'
import { SERVER_DATA } from './utils/prop-type-shape'

const App = (props) => {
  const { serverData } = props
  const spinnerRef = useRef(null)

  /*
    Creating an appContext object which will have pageProps and reqContextData or
    any other data in future based on the requirements, so that we can save this through
    the contextProvider for all the components to access.
    pageProps -  This will will have the data required for the page to render like components data, 
                  RC data, ELMO data, any other related data on a page level.
    reqContextData - client will not have access to the express request. so this will hold the req data
                     concolidated to the UI needs.

    The context is used to manage global data, e.g. global state, req data, theme, services, user settings, and more
    */
  const { pageProps, reqContextData } = serverData
  const { isLoggedIn, isProd } = reqContextData
  const appContextData = {
    pageProps,
    reqContextData,
  }

  const spinnerTimeOut = isProd ? 500 : 1500
  useEffect(() => {
    const timerId = setTimeout(() => {
      spinnerRef.current.remove()
    }, spinnerTimeOut)

    return () => {
      clearTimeout(timerId)
    }
  }, [])

  return (
    <>
      <WorldReadyContextProvider locale={serverData.locality.locale}>
        <AppContextProvider appContextData={appContextData}>
          <ThemeProvider theme={PAYPAL_THEME}>
            <div
              data-testid="hc-page-loader"
              ref={spinnerRef}
              className="hc-page__loader"
            >
              <LoadingSpinner screenReaderText="loading" size="xl" />
            </div>
            <Header
              isLoggedIn={isLoggedIn}
              reqContextData={reqContextData}
              serverData={serverData}
            />
            <div className="main-page-container">
              <Page {...appContextData} />
            </div>
            <Footer
              isLoggedIn={isLoggedIn}
              reqContextData={reqContextData}
              serverData={serverData}
            />
          </ThemeProvider>
        </AppContextProvider>
      </WorldReadyContextProvider>
    </>
  )
}

App.propTypes = {
  serverData: PropTypes.shape(SERVER_DATA),
}
export default App
